<template>
  <div :class="$options.name">
    <v-card>
      <wms-form
        :wms-data="single"
        is-edit
        @submit="onSubmit"
      />
    </v-card>
  </div>
</template>

<script>
import WmsForm from '@/views/settings/wms/components/WmsForm.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'wms-item',
  asyncData({ store, route }) {
    const { id } = route.params;

    const actions = [
      store.dispatch('wms/getItem', id),
    ];

    return Promise.all(actions);
  },
  components: {
    WmsForm,
  },
  computed: {
    ...mapState('wms', ['single']),
  },
  methods: {
    ...mapActions('wms', ['update']),

    ...mapActions(['showNotify']),

    async onSubmit(form) {
      this.isLoading = true;
      try {
        await this.update(form);
        this.showNotify({ message: 'Форма успешно обновлена' });
      } catch (e) {
        this.showNotify({ type: 'error', message: 'Что-то пошло не так' });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>

</style>
